const STORAGE_KEY = "moebix_recently_viewed";
const MAX_ITEMS = 20;

interface RecentProduct {
  id: string;
  name: string;
  image: string | null;
  price: number;
  originalPrice: number | null;
  merchantName: string;
  slug: string | null;
  brand: string | null;
  category?: { slug: string; parent?: { slug: string; parent?: { slug: string } } } | null;
}

export function useRecentlyViewed() {
  const items = useState<RecentProduct[]>("recently-viewed", () => []);

  function load() {
    if (typeof window === 'undefined') return;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      items.value = raw ? JSON.parse(raw) : [];
    } catch {
      items.value = [];
    }
  }

  function add(product: RecentProduct) {
    if (typeof window === 'undefined') return;
    const filtered = items.value.filter((p) => p.id !== product.id);
    filtered.unshift(product);
    items.value = filtered.slice(0, MAX_ITEMS);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.value));
    } catch { /* quota exceeded */ }
  }

  function getExcluding(productId: string, limit = 8): RecentProduct[] {
    return items.value.filter((p) => p.id !== productId).slice(0, limit);
  }

  return { items, load, add, getExcluding };
}
